import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取红包设置列表 **/
    GET_CASH_LIST(data) {
        controller='EsCasher';
        action='GetList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 新增红包设置 **/
    ADD_CASH(data) {
        controller='EsCasher';
        action='AddCash';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    /** 获取红包信息详情 **/
    GET_CASH_INFO(data) {
        controller='EsCasher';
        action='GetCashInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    /** 修改红包设置信息 **/
    SAVE_CASH(data) {
        controller='EsCasher';
        action='EditCash';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    /** 红包设置上下架 **/
    CHANGE_CASH_SHOW(data) {
        controller='EsCasher';
        action='SetCashIsshow';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    /** 编辑红包设置排序 **/
    CHANGE_CASH_SORT(data) {
        controller='EsCasher';
        action='EditCashSort';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    /** 删除红包设置信息 **/
    DEL_CASH(data) {
        controller='EsCasher';
        action='DelCash';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    /** 获取红包信息详情 **/
    GET_CASH_DETAIL(data) {
        controller='EsCasher';
        action='GetCashDetail';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

   
}